import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./ExcluirHorarios.css";

const API_URL = "https://acesso.cronosagenda.com.br/api";

const ExcluirHorarios = () => {
    const [funcionarios, setFuncionarios] = useState([]);
    const [funcionarioSelecionado, setFuncionarioSelecionado] = useState("");
    const [diaSelecionado, setDiaSelecionado] = useState("");
    const [horarioInicio, setHorarioInicio] = useState("");
    const [horarioFim, setHorarioFim] = useState("");
    const [erro, setErro] = useState("");
    const [sucesso, setSucesso] = useState("");
    const [loading, setLoading] = useState(false);
    const [carregandoFuncionarios, setCarregandoFuncionarios] = useState(true);

    const navigate = useNavigate();

    const diasSemana = [
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sábado",
        "Domingo",
    ];

    useEffect(() => {
        let ativo = true;

        const fetchFuncionarios = async () => {
            try {
                await axios.get(`${API_URL}/verificar-autenticacao`, {
                    withCredentials: true,
                });

                const response = await axios.get(`${API_URL}/funcionarios`, {
                    withCredentials: true,
                });

                if (ativo) {
                    setFuncionarios(response.data || []);
                }
            } catch (error) {
                console.error("Erro ao carregar funcionários:", error);

                if (!ativo) return;

                if (
                    error.response?.status === 401 ||
                    error.response?.status === 403
                ) {
                    navigate("/login");
                    return;
                }

                setErro("Erro ao carregar funcionários. Tente novamente.");
            } finally {
                if (ativo) {
                    setCarregandoFuncionarios(false);
                }
            }
        };

        fetchFuncionarios();

        // Mantidos os bloqueios que já existiam no componente.
        const disableInspect = (event) => {
            if (
                event.key === "F12" ||
                (event.ctrlKey &&
                    event.shiftKey &&
                    event.key.toLowerCase() === "i") ||
                (event.ctrlKey && event.key.toLowerCase() === "u")
            ) {
                event.preventDefault();
            }
        };

        const disableRightClick = (event) => event.preventDefault();

        document.addEventListener("contextmenu", disableRightClick);
        document.addEventListener("keydown", disableInspect);

        return () => {
            ativo = false;
            document.removeEventListener("contextmenu", disableRightClick);
            document.removeEventListener("keydown", disableInspect);
        };
    }, [navigate]);

    useEffect(() => {
        if (!sucesso) return;

        const timer = setTimeout(() => {
            setSucesso("");
        }, 5000);

        return () => clearTimeout(timer);
    }, [sucesso]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setErro("");
        setSucesso("");

        if (
            !funcionarioSelecionado ||
            !diaSelecionado ||
            !horarioInicio ||
            !horarioFim
        ) {
            setErro("Todos os campos são obrigatórios.");
            return;
        }

        if (horarioInicio >= horarioFim) {
            setErro("O horário de início deve ser antes do horário de fim.");
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(
                `${API_URL}/horarios_excluidos`,
                {
                    funcionario_id: funcionarioSelecionado,
                    dia_da_semana: diaSelecionado,
                    horario_inicio: horarioInicio,
                    horario_fim: horarioFim,
                },
                {
                    withCredentials: true,
                }
            );

            if (response.status === 201) {
                setSucesso("Horário excluído com sucesso!");
                setHorarioInicio("");
                setHorarioFim("");
            } else {
                setErro("Não foi possível excluir o horário.");
            }
        } catch (err) {
            console.error("Erro ao excluir horário:", err);

            if (
                err.response?.status === 401 ||
                err.response?.status === 403
            ) {
                navigate("/login");
                return;
            }

            setErro(
                "Erro ao excluir horário: " +
                    (err.response?.data?.error ||
                        err.message ||
                        "Erro inesperado.")
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="excluir-horarios-page">
            <section className="excluir-horarios-card">
                <header className="excluir-horarios-header">
                    <div className="excluir-horarios-header-icon">
                        <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            aria-hidden="true"
                        >
                            <circle
                                cx="12"
                                cy="12"
                                r="9"
                                stroke="currentColor"
                                strokeWidth="1.7"
                            />
                            <path
                                d="M12 7V12L15.5 14"
                                stroke="currentColor"
                                strokeWidth="1.7"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M4.8 4.8L3.5 3.5M19.2 4.8L20.5 3.5"
                                stroke="currentColor"
                                strokeWidth="1.7"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>

                    <div className="excluir-horarios-heading">
                        <span className="excluir-horarios-eyebrow">
                            GESTÃO DE AGENDA
                        </span>
                        <h1>Excluir horários</h1>
                        <p>
                            Bloqueie um intervalo da agenda de um profissional
                            em um dia específico da semana.
                        </p>
                    </div>
                </header>

                <div className="excluir-horarios-divider" />

                <form
                    className="excluir-horarios-form"
                    onSubmit={handleSubmit}
                >
                    <div className="excluir-horarios-section-heading">
                        <span className="excluir-horarios-step">01</span>
                        <div>
                            <h2>Configurar bloqueio</h2>
                            <p>Preencha os dados do intervalo que deseja excluir.</p>
                        </div>
                    </div>

                    <div className="excluir-horarios-field">
                        <label htmlFor="funcionario">
                            Profissional
                            <span className="excluir-horarios-required">*</span>
                        </label>

                        <div className="excluir-horarios-input-wrap">
                            <svg
                                className="excluir-horarios-field-icon"
                                viewBox="0 0 24 24"
                                fill="none"
                                aria-hidden="true"
                            >
                                <circle
                                    cx="12"
                                    cy="8"
                                    r="3.5"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                />
                                <path
                                    d="M5 20V18.5C5 15.74 7.24 13.5 10 13.5H14C16.76 13.5 19 15.74 19 18.5V20"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                    strokeLinecap="round"
                                />
                            </svg>

                            <select
                                id="funcionario"
                                value={funcionarioSelecionado}
                                onChange={(event) =>
                                    setFuncionarioSelecionado(event.target.value)
                                }
                                disabled={carregandoFuncionarios || loading}
                                required
                            >
                                <option value="">
                                    {carregandoFuncionarios
                                        ? "Carregando profissionais..."
                                        : "Selecione um profissional"}
                                </option>

                                {funcionarios.map((func) => (
                                    <option key={func.id} value={func.id}>
                                        {func.nome}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="excluir-horarios-field">
                        <label htmlFor="diaSemana">
                            Dia da semana
                            <span className="excluir-horarios-required">*</span>
                        </label>

                        <div className="excluir-horarios-input-wrap">
                            <svg
                                className="excluir-horarios-field-icon"
                                viewBox="0 0 24 24"
                                fill="none"
                                aria-hidden="true"
                            >
                                <rect
                                    x="3.5"
                                    y="5"
                                    width="17"
                                    height="15.5"
                                    rx="3"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                />
                                <path
                                    d="M7.5 3.5V7M16.5 3.5V7M3.5 9.5H20.5"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                    strokeLinecap="round"
                                />
                            </svg>

                            <select
                                id="diaSemana"
                                value={diaSelecionado}
                                onChange={(event) =>
                                    setDiaSelecionado(event.target.value)
                                }
                                disabled={loading}
                                required
                            >
                                <option value="">Selecione o dia da semana</option>

                                {diasSemana.map((dia) => (
                                    <option key={dia} value={dia}>
                                        {dia}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="excluir-horarios-time-section">
                        <div className="excluir-horarios-time-heading">
                            <div>
                                <h3>Intervalo a bloquear</h3>
                                <p>Defina o horário de início e de término.</p>
                            </div>
                            <span className="excluir-horarios-time-badge">
                                <span />
                                Bloqueio
                            </span>
                        </div>

                        <div className="excluir-horarios-time-grid">
                            <div className="excluir-horarios-field">
                                <label htmlFor="horarioInicio">
                                    Início
                                    <span className="excluir-horarios-required">
                                        *
                                    </span>
                                </label>

                                <div className="excluir-horarios-input-wrap">
                                    <svg
                                        className="excluir-horarios-field-icon"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        aria-hidden="true"
                                    >
                                        <circle
                                            cx="12"
                                            cy="12"
                                            r="9"
                                            stroke="currentColor"
                                            strokeWidth="1.7"
                                        />
                                        <path
                                            d="M12 7V12L15 14"
                                            stroke="currentColor"
                                            strokeWidth="1.7"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>

                                    <input
                                        id="horarioInicio"
                                        type="time"
                                        value={horarioInicio}
                                        onChange={(event) =>
                                            setHorarioInicio(event.target.value)
                                        }
                                        disabled={loading}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="excluir-horarios-time-separator">
                                <span />
                                <span />
                            </div>

                            <div className="excluir-horarios-field">
                                <label htmlFor="horarioFim">
                                    Término
                                    <span className="excluir-horarios-required">
                                        *
                                    </span>
                                </label>

                                <div className="excluir-horarios-input-wrap">
                                    <svg
                                        className="excluir-horarios-field-icon"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        aria-hidden="true"
                                    >
                                        <circle
                                            cx="12"
                                            cy="12"
                                            r="9"
                                            stroke="currentColor"
                                            strokeWidth="1.7"
                                        />
                                        <path
                                            d="M12 7V12L15 14"
                                            stroke="currentColor"
                                            strokeWidth="1.7"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>

                                    <input
                                        id="horarioFim"
                                        type="time"
                                        value={horarioFim}
                                        onChange={(event) =>
                                            setHorarioFim(event.target.value)
                                        }
                                        min={horarioInicio || undefined}
                                        disabled={loading}
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="excluir-horarios-preview">
                            <span className="excluir-horarios-preview-icon">
                                <svg
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M12 8V12M12 16H12.01M10.3 3.9L2.9 17A2 2 0 0 0 4.65 20H19.35A2 2 0 0 0 21.1 17L13.7 3.9A2 2 0 0 0 10.3 3.9Z"
                                        stroke="currentColor"
                                        strokeWidth="1.7"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>

                            <p>
                                O intervalo informado ficará indisponível para
                                agendamentos no dia da semana selecionado.
                            </p>
                        </div>
                    </div>

                    {erro && (
                        <div
                            className="excluir-horarios-alert excluir-horarios-alert-error"
                            role="alert"
                            aria-live="assertive"
                        >
                            <span className="excluir-horarios-alert-icon">!</span>
                            <p>{erro}</p>
                            <button
                                type="button"
                                onClick={() => setErro("")}
                                aria-label="Fechar mensagem"
                            >
                                ×
                            </button>
                        </div>
                    )}

                    <div className="excluir-horarios-actions">
                        <button
                            type="button"
                            className="excluir-horarios-btn excluir-horarios-btn-secondary"
                            onClick={() => window.history.back()}
                            disabled={loading}
                        >
                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                aria-hidden="true"
                            >
                                <path
                                    d="M19 12H5M12 19L5 12L12 5"
                                    stroke="currentColor"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            Voltar
                        </button>

                        <button
                            type="submit"
                            className="excluir-horarios-btn excluir-horarios-btn-primary"
                            disabled={loading || carregandoFuncionarios}
                        >
                            {loading ? (
                                <>
                                    <span className="excluir-horarios-spinner" />
                                    Excluindo horário...
                                </>
                            ) : (
                                <>
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        aria-hidden="true"
                                    >
                                        <path
                                            d="M12 3V21M3 12H21"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                    Excluir horário
                                </>
                            )}
                        </button>
                    </div>
                </form>

                <footer className="excluir-horarios-footer">
                    <span className="excluir-horarios-footer-dot" />
                    Cronos Agenda · Gestão simplificada
                </footer>
            </section>

            {sucesso && (
                <div
                    className="excluir-horarios-toast"
                    role="status"
                    aria-live="polite"
                >
                    <span className="excluir-horarios-toast-check">✓</span>
                    <div>
                        <strong>Operação concluída</strong>
                        <p>{sucesso}</p>
                    </div>
                    <button
                        type="button"
                        onClick={() => setSucesso("")}
                        aria-label="Fechar notificação"
                    >
                        ×
                    </button>
                </div>
            )}
        </main>
    );
};

export default ExcluirHorarios;